define('app-Search/core/serviceUrls',[],function () {
    return {
        durations: window.location.protocol + '//' + window.location.host + '/searchservice/getdurationsfor',
        dates: window.location.protocol + '//' + window.location.host + '/searchservice/getcalendarofdeparturesfor',
        destinations: window.location.protocol + '//' + window.location.host + '/searchservice/matchesfor',
        styles: window.location.protocol + '//' + window.location.host + '/searchservice/index',
        settings: window.location.protocol + '//' + window.location.host + '/searchservice/getsettingsfor',
        resultCount: window.location.protocol + '//' + window.location.host + '/searchservice/getresultcount',
        searchResultServiceUrl: window.location.protocol + '//' + window.location.host + '/searchservice/getresults',
        searchResultFacetServiceUrl: window.location.protocol + '//' + window.location.host + '/searchresults/getfacetsfor',
        cruiseSearchResultUrl: window.location.protocol + '//' + window.location.host + '/cruisesearch/getresults',
        cruiseFiltersUrl: window.location.protocol + '//' + window.location.host + '/cruisesearch/getcruisefilters'
    };
});
